module.exports = "//static.hsappstatic.net/signup-ui-lego/static-1.7799/images/cmsfree-marketplace/cmsfree-marketplace@2x.png"